import React, { useState } from 'react'
import tw from 'twin.macro'
import { navigate, Link } from 'gatsby'
import styled from 'styled-components'
import { globalHistory } from '@reach/router'
import getCategoryList, { nth_occurrence } from '../helpers/getCategoryList'

import { ReactComponent as DownIcon } from '../../node_modules/feather-icons/dist/icons/arrow-down.svg'
import { ReactComponent as UpIcon } from '../../node_modules/feather-icons/dist/icons/arrow-up.svg'

// const CategoryContainer = tw.div`hidden md:block md:w-1/6`

const CategoryLabelTitle = tw.h1`tracking-wide text-base text-gray-700 font-semibold`
// const CategoryTitleContainer = tw.div`px-2 py-1 bg-green-50 hover:bg-green-500 `
const CategoryTitleActiveContainer = tw.div`px-2 py-1 bg-green-500`
const CategoryTitle = tw.p`text-base cursor-pointer group-hover:text-white leading-8 text-gray-700 font-semibold`
const CategoryTitleActive = styled(CategoryTitle)`
  ${tw`text-green-50 pb-1 border-b-2 border-transparent font-bold hover:text-white`}
`

function CategoryComponent({ categoryList }) {
  const [isExpanded, setIsExpanded] = useState(true)
  const currentPath = globalHistory.location.pathname.replace(/%20/g, ' ')

  var tempListOfCategories = getCategoryList(categoryList)

  return (
    <div>
      <div className="p-2 h-auto">
        <div
          onClick={() => setIsExpanded((prev) => !prev)}
          className="bg-gray-50 rounded-md p-2 cursor-pointer flex flex-row justify-between mb-2"
        >
          <div>
            <CategoryLabelTitle>Categories</CategoryLabelTitle>
          </div>
          <div>
            {!isExpanded ? (
              <DownIcon tw="text-gray-400"></DownIcon>
            ) : (
              <UpIcon tw="text-gray-400"></UpIcon>
            )}
          </div>
        </div>
        {tempListOfCategories.map(({ node }) => {
          let items

          if (isExpanded) {
            // List of all items
            items =
              node.path === currentPath ||
              node.path ===
                currentPath.substring(
                  0,
                  nth_occurrence(currentPath, '/', 3)
                ) ? (
                <CategoryTitleActiveContainer key={node.internalComponentName}>
                  <CategoryTitleActive
                    as={Link}
                    key={node.internalComponentName}
                    to={node.path}
                  >
                    {node.internalComponentName}
                  </CategoryTitleActive>
                </CategoryTitleActiveContainer>
              ) : (
                <div key={node.internalComponentName} className="group px-2 py-1 bg-green-50 hover:bg-green-500 " onClick={() => navigate(node.path)}>
                  <CategoryTitle
                    key={node.internalComponentName}
                  >
                    {node.internalComponentName}
                  </CategoryTitle>
                </div>
              )
          } else {
            items =
              node.path === currentPath ||
              node.path ===
                currentPath.substring(
                  0,
                  nth_occurrence(currentPath, '/', 3)
                ) ? (
                <CategoryTitleActiveContainer key={node.internalComponentName}>
                  <CategoryTitleActive
                    as={Link}
                    key={node.internalComponentName}
                    to={node.path}
                  >
                    {node.internalComponentName}
                  </CategoryTitleActive>
                </CategoryTitleActiveContainer>
              ) : (
                <></>
              )
          }

          return items
        })}
      </div>
    </div>
  )
}

export default CategoryComponent
